var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9996 10C28.983 10 28.0496 9.41671 27.583 8.51671L26.383 6.10004C25.6163 4.58337 23.6163 3.33337 21.9163 3.33337H18.0996C16.383 3.33337 14.383 4.58337 13.6163 6.10004L12.4163 8.51671C11.9496 9.41671 11.0163 10 9.99963 10C6.38296 10 3.51629 13.05 3.74963 16.65L4.61629 30.4167C4.81629 33.85 6.6663 36.6667 11.2663 36.6667H28.733C33.333 36.6667 35.1663 33.85 35.383 30.4167L36.2496 16.65C36.483 13.05 33.6163 10 29.9996 10ZM17.4996 12.0834H22.4996C23.183 12.0834 23.7496 12.65 23.7496 13.3334C23.7496 14.0167 23.183 14.5834 22.4996 14.5834H17.4996C16.8163 14.5834 16.2496 14.0167 16.2496 13.3334C16.2496 12.65 16.8163 12.0834 17.4996 12.0834ZM19.9996 30.2C16.8996 30.2 14.3663 27.6834 14.3663 24.5667C14.3663 21.45 16.883 18.9334 19.9996 18.9334C23.1163 18.9334 25.633 21.45 25.633 24.5667C25.633 27.6834 23.0996 30.2 19.9996 30.2Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6a1b9ff96140cb9061e5a750e417504c.svg";
export { ForwardRef as ReactComponent };